import request, { downloadFile } from "../utils/request";

export async function getSmartBeanList(params) {
  const res = await request({
    url: "/bean/volunteer_bean_account",
    params,
    method: "get",
  });

  return res;
}

export async function getSmartBeanDetailList(params) {
  const res = await request({
    url: "/bean/volunteer_bean_account_detail",
    method: "get",
    params: params,
  });

  return res;
}
///bean/volunteer_bean_account/total_count

/**
 * 增加智慧豆
 * @param {*} data
 * @returns
 */
export async function addSmartBeansReq(data) {
  const res = await request({
    url: "/bean/input",
    data,
    method: "post",
  });

  return res;
}

/**
 * 消耗智慧豆
 * @param {*} data
 * @returns
 */
export async function reduceSmartBeansReq(data) {
  const res = await request({
    url: "/bean/consume",
    data,
    method: "post",
  });

  return res;
}

/**
 * 获取审批状态数据
 * @param {*} params
 * @returns
 */
export async function getSmartBeanAuditStatusList(params) {
  console.log("params+++:", params);
  const res = await request({
    url: "/bean/audit_list",
    method: "get",
    params: params,
  });

  return res;
}

/**
 * 批量审批
 * @param {*} params
 * @returns
 */
export async function auditApllyStatus(params) {
  const res = await request({
    url: "/bean/audit",
    method: "get",
    params: params,
  });

  return res;
}

/**
 *
 * @param {*} params
 * @returns
 */
export async function exportSmartBeansExelFile(params) {
  const res = await downloadFile(
    "/bean/volunteer_bean_account/export",
    "智慧豆列表.xlsx",
    params
  );

  return res;
}

/**
 * 批量上传智慧豆
 * @param {*} data
 * @returns
 */
export async function uploadSmartBeansByExel(data) {
  const res = await request({
    url: "/bean/upload",
    params: data,
    method: "get",
  });

  return res;
}

export async function exportSmartBeansAuditExelFile(params) {
  if (params?.page_no) delete params.page_no;

  if (params?.page_size) delete params.page_size;
  const res = await downloadFile(
    "/bean/audit_list/excel",
    "智慧豆审核.xlsx",
    params
  );

  return res;
}
